/*
 The MIT License (MIT)

 Copyright (C) 2017-2023 Stefano Cappa (Ks89)

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NON INFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */

import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

/**
 * Directive to add fallback image if the original one is not reachable.
 */
@Directive({
  selector: '[ksFallbackImage]'
})
export class FallbackImageDirective {
  @Input()
  fallbackImg: string | SafeResourceUrl | undefined;

  @Output()
  fallbackApplied: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  @HostListener('error') onError(): void {
    if (!this.fallbackImg) {
      this.fallbackApplied.emit(false);
      return;
    }
    this.renderer.setAttribute(this.el.nativeElement, 'src', this.fallbackImg.toString());
    this.fallbackApplied.emit(true);
  }
}
